import { render, staticRenderFns } from "./RefundRequestDetailsSection.vue?vue&type=template&id=04b8933d&"
import script from "./RefundRequestDetailsSection.vue?vue&type=script&lang=js&"
export * from "./RefundRequestDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./RefundRequestDetailsSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports